import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { RootState } from '../../../redux/store';
import { getCharityLogoUrl } from '../../../utils/media/cents-media';

const Branding: React.FC = () => {
  const charity = useSelector((state: RootState) => state.auth.charity)
  if (!charity) {
    return <></> // TODO: Add a loader
  }

  return (
    <Link to={'/'}>
      <div className='branding flex items-center h-[90px] md:h-[12vh] max-w-[60vw] md:max-w-[calc(25vw)] lg:max-w-[calc(20vw)] xl:max-w-[calc(16vw)] 2xl:max-w-[calc(14vw)]'>
        <div className='flex justify-center fit-content min-w-10 mr-3 md:mr-4 rounded-lg'>
          <img src={getCharityLogoUrl(charity?._id)} className='object-contain w-auto h-12'></img>
        </div>
        <h1 className='text-lg font-medium leading-6'>{charity?.name}</h1>
      </div>
    </Link>
  );
};

export default Branding;

// <span className='text-[16px] font-normal pl-3'>/&nbsp;&nbsp;dashboard</span> md:max-w-md-right-fr-width